module.exports = __webpack_public_path__ + "content/a475f75e8e9817562405301dd64b5de8.svg";